<template>
	<div id="ModalDialogComponent" @keydown.esc="escKeyPressedHandler">
		<div class="modal fade show d-block" tabindex="-1" role="dialog" aria-hidden="true" aria-modal="true">
			<div class="modal-dialog modal-dialog-centered" :class="size ? `modal-${size}` : ''" role="document">
				<div class="modal-content" ref="modalContent">
					<div class="modal-header draggable-handler" @mousedown.prevent.stop="mouseDownHandler" @mouseup.prevent.stop="mouseUpHandler"><h6 class="modal-title"><slot name="title"></slot></h6><div class="modal-header-message"><slot name="infoMessage"></slot></div></div>
					<div class="modal-body pt-0"><slot name="body"></slot></div>
					<div class="modal-body-message"><slot name="errorMessage"></slot></div>
					<div class="modal-footer">
						<template v-for="(buttonGroup, buttonGroupIdx) in buttons">
							<template v-for="(button, buttonIdx) in buttonGroup">
								<button type="button" class="btn" :class="buttonClasses(buttonGroupIdx, buttonIdx)" @click="button.clickFn" :disabled="button.isDisabled" v-html="button.caption" :key="button.name"></button>
							</template>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['buttons', 'size'],

	data() {
		return {
			draggableElement: null,
			initX: null,
			initY: null,
			mousePressX: null,
			mousePressY: null,
		};
	},

	methods: {
		buttonClasses(buttonGroupIdx, buttonIdx) {
			let lastButtonInGroup = (buttonIdx === (this.buttons[buttonGroupIdx].length - 1)),
				lastButtonGroup = (buttonGroupIdx === (this.buttons.length - 1));

			return this.buttons[buttonGroupIdx][buttonIdx].classes + ((lastButtonInGroup && !lastButtonGroup) ? ' mr-auto' : '');
		},

		escKeyPressedHandler() {
			this.$emit('escKeyPressed');
		},

		mouseDownHandler(event) {
			let element = this.draggableElement;

			this.initX = element.offsetLeft;
			this.initY = +element.style.top.slice(0, -2);
			this.mousePressX = event.clientX;
			this.mousePressY = event.clientY;

			element.addEventListener('mousemove', this.mouseMoveHandler, false);
		},

		mouseMoveHandler(event) {
			let newX = `${this.initX + event.clientX - this.mousePressX}px`,
				newY = `${this.initY + event.clientY - this.mousePressY}px`;

			this.draggableElement.style.left = newX;
			this.draggableElement.style.top = newY;
		},

		mouseUpHandler() {
			this.draggableElement.removeEventListener('mousemove', this.mouseMoveHandler, false);
		},
	},

	mounted() {
		this.$emit('modalDialogMounted');
		this.draggableElement = this.$refs.modalContent;
		this.draggableElement.style.left = this.draggableElement.style.top = '0px';
	},
};
</script>

<style lang="scss">
	.draggable-handler {
		cursor: move;
	}
</style>
